var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23.868 23.868",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.066 -12.066)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26313 0 0 .26313 .13157 -247.5)",
    fill: "currentColor",
    d: "m45.354 986.46v90.709h52.913v-11.339h-7.5591v-11.339h-7.5591v11.339h-26.457v-34.016h26.457v7.5591h7.5591v-18.898h-7.5591v3.7796h-26.457v-26.457h26.457v7.559h7.5591v-7.559h34.016v68.032h-7.5591v11.339h18.898v-90.709z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.16d10f1fcbfc211c4f60d51a5a6c4dd2.svg";
export { ForwardRef as ReactComponent };